import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BidCategoryView } from '@api-proxies';
import { BidCategoryService } from '@http/clients/bid-category.service';
import { ReportsService } from '@services/reports.service';
import { EditorComponentBase, GenericDropdownMultiselectComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reporting-bid-categories-editor',
    templateUrl: './reporting-bid-categories-editor.component.html',
    styleUrls: ['./reporting-bid-categories-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportingBidCategoriesEditorComponent
    extends EditorComponentBase<number[] | null>
    implements OnInit, OnDestroy
{
    items: BidCategoryView[] = [];
    selectedItems?: BidCategoryView[];
    subscription?: Subscription;

    private readonly bidCategoryService = inject(BidCategoryService);
    private readonly reportsService = inject(ReportsService);

    constructor() {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.items = await this.bidCategoryService.search();
        this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
            if (ready && this.bindingProperty !== null && this.bindingProperty?.length) {
                this.selectedItems = await this.bidCategoryService.getByIds(this.bindingProperty);
            } else if (ready && (this.bindingProperty === null || this.bindingProperty === undefined)) {
                this.selectedItems = [];
            }
        });
    }

    async onSelectedItemsChange(): Promise<void> {
        if (this.selectedItems) {
            this.bindingProperty = this.selectedItems.length ? this.selectedItems.map((item) => item.id) : null;
            this.valueChange.emit();
        }
    }

    async onEntityTextChange(text: string) {
        this.items = await this.bidCategoryService.search(text);
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
